import script from "./ChapterEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ChapterEdit.vue?vue&type=script&setup=true&lang=js"

import "./ChapterEdit.vue?vue&type=style&index=0&id=410de32c&lang=css"

const __exports__ = script;

export default __exports__